<template>
  <div class="card" v-show="currentCardId == cardId">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>{{ title }}</h2>
        <p>{{ description }}</p>
        <div class="add-item">
          <el-button
            style="background-color: #004d40; border-color: #004d40"
            type="success"
            @click="dialogVisible = true"
            >例文から追加</el-button
          >
        </div>
      </div>
      <div class="card-content">
        <LetterExampleSentenceDialog
          :value="dialogVisible"
          :name="dialogName"
          :items="filteredItems"
          @input="dialogVisible = $event"
          @select="onSelect"
        />
        <el-input
          type="textarea"
          v-model="formatData[fieldKey]"
          :autosize="{ minRows: 5, maxRows: 15 }"
        />
        <div class="attention-limit character" v-if="previewErrors[errorKey]">
          <i class="el-icon-warning"></i>
          入力可能な文字数をオーバーしています。文章を短くしてください。
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useLetterFormatData } from '@/composables/format-edit/useLetterFormatData'
import LetterExampleSentenceDialog, {
  type LetterExampleSentenceItem
} from '@/components/format-edit/letter/LetterExampleSentenceDialog.vue'

const props = defineProps<{
  currentCardId?: string
  cardId: string
  title: string
  description: string
  fieldKey: 'introSummary' | 'entrySummary'
  errorKey: string
  dialogName: string
  sentences: LetterExampleSentenceItem[]
  previewErrors: Record<string, string | undefined>
}>()

const formatData = useLetterFormatData()
const dialogVisible = ref(false)

const filteredItems = computed(() => {
  const selectedOccupation = formatData.occupation
  return (props.sentences || []).filter(
    (item) => item.type === selectedOccupation
  )
})

function onSelect(sentences: string) {
  formatData[props.fieldKey] = sentences
}
</script>
